import React from 'react';
import { NavLink } from '../NavLink';
import { NavSubContainer, SidebarNavContainer } from './styles';
import { useRouter } from 'next/router';
import axios from 'axios';
import { useSelectedPnld } from '@/HOC/useSelectedPnld';

export function SidebarNav() {
  const router = useRouter();
  const { pnldId } = useSelectedPnld();

  async function SignOut() {
    try {
      await axios.post('/api/logout');
    } catch (error) {}
    router.push('/');
  }

  return (
    <SidebarNavContainer>
      <NavSubContainer>
        <NavLink
          href={`/home${pnldId ? `?pnldId=${pnldId}` : ''}`}
          text="Home"
        />
        <NavLink href={`/OEDs/${pnldId ?? ''}`} text="Biblioteca" />
        <NavLink
          href={`/list${pnldId ? `?pnldId=${pnldId}` : ''}`}
          text="Listas"
        />
      </NavSubContainer>

      <NavSubContainer>
        <NavLink
          href={`/configuracoes${pnldId ? `?pnldId=${pnldId}` : ''}`}
          text="Configurações"
        />
        <NavLink
          href={`/ajuda${pnldId ? `?pnldId=${pnldId}` : ''}`}
          text="Ajuda"
        />

        <button type="button" onClick={SignOut}>
          Sair
        </button>
      </NavSubContainer>
    </SidebarNavContainer>
  );
}
